import OPBCreateNewPage from "./OP3Builder/Pages/OPBCreateNewPage";

/**
 * @todo Boris & Davor - this file should be inside OP Builder - with all files inside /OP3Builder/ folder
 */
class OP3Builder {
    constructor() {
        this.secondaryMenu = window.OP3General.createMovingBorderMenu('.op3-secondary-menu');
        this.createPageSlider = null;
        this.movingImage = null;

        window.OP3General.pages.createNewPage = new OPBCreateNewPage();

        this['jQueryInit']();
    }

    /**
     * jQuery initialization
     */
    ['jQueryInit']() {
        let _this = this;
        let $ = jQuery;

        $(document).ready(() => {
            _this.createPageSlider = window.OP3General.createWallopSlider('.opb_create-new-page-slider', $);

            _this['combineMenuAndSlider']();
        });
    }

    /**
     * Changing menu and slides together when moved over menu item or slider swipe
     */
    ['combineMenuAndSlider']() {
        let _this = this;

        _this.movingImage = window.OP3General.createMovingImage('.opb-template-preview', $);

        _this.secondaryMenu.on('movingBorderMenu:change', ($menuLI) => {
            _this.createPageSlider.changeSlide($menuLI.index());
            _this.movingImage.destroy();
            _this.movingImage = window.OP3General.createMovingImage('.opb-template-preview', $);
        });
        _this.secondaryMenu.triggerInitialEvents();
        _this.createPageSlider.on('wallopSlider:change', (event) => {
            _this.secondaryMenu.changeMenu(event.detail.currentItemIndex);
        });
    }
}

export default OP3Builder;

window.OP3General.pages.builder = new OP3Builder();


// WEBPACK FOOTER //
// ./resources/assets/js/OP3Builder.js